import { combineReducers } from 'redux';

import error from './error';
import mapReady from './mapReady';
import visibleLayers from './visibleLayers';
import sketchToolActive from './sketchToolActive';
import drawComplete from './drawComplete';
import timeSlidersEnabled from './timeslidersEnabled';
import annotationToolActive from './annotationToolActive';
import annotations from './annotations';
import contextualSketchToolActive from './contextualSketchToolActive';
import riverSketchToolActive from './riverSketchToolActive';
import myLayers from './myLayers';
import loader from './loader';
import performAuditLayers from './performAuditLayers';
import layerModal from './layerModal';
import tempGraphic from './tempGraphic';
import swipeToolActive from './swipeToolActive';
import rasterThresholds from './rasterThresholds';
import imageRenderingRule from './imageryRenderingRule';
import disabledLayers from './disabledLayers';

const mapview = combineReducers({
  error,
  mapReady,
  visibleLayers,
  disabledLayers,
  sketchToolActive,
  swipeToolActive,
  drawComplete,
  annotationToolActive,
  annotations,
  contextualSketchToolActive,
  riverSketchToolActive,
  myLayers,
  loader,
  performAuditLayers,
  layerModal,
  tempGraphic,
  rasterThresholds,
  imageRenderingRule,
  timeSlidersEnabled
});

export default mapview;
